import { FC, ReactNode, useContext } from 'react';
import styled from 'styled-components';
import { SidebarStateContext } from '../../providers/MainProviders';
import { constants } from '../../constants/constants';

interface Props {
  children?: ReactNode;
}

const MainContentContainer = styled.main<{ expanded: boolean }>`
  margin-left: ${(props) =>
    props.expanded
      ? constants.components.SIDEBAR_EXPANDED_WIDTH
      : constants.components.SIDEBAR_COLLAPSED_WIDTH};
  height: 100%;
  background-color: #feffff;
`;

const Main: FC<Props> = ({ children }) => {
  const { expanded } = useContext(SidebarStateContext);
  return <MainContentContainer expanded={expanded}>{children}</MainContentContainer>;
};

export default Main;
